import urlHelper from '../Helpers/urlHelper';

export default class TpPrePaymentPaymentItem {
  constructor(item) {
    if (item) {
      this.TpClientPaymentId = item.tpClientPaymentId;
      this.EntryDateUtc = item.entryDateUtc;
      this.AmountPaid = item.amountPaid;
      this.CheckNumber = item.checkNumber;
      this.LineItemPaymentId = item.lineItemPaymentId;
      this.CurrencyCode = item.currencyCode;
      return;
    }
    this.TpClientPaymentId = '';
    this.EntryDateUtc = '';
    this.AmountPaid = '';
    this.CheckNumber = '';
    this.LineItemPaymentId = '';
    this.CurrencyCode = '';
  }

  static MoneyFields = ['AmountPaid'];
  static MoneyFieldsSecondary = ['AmountPaid'];

  static Currency() {
    return 'CurrencyCode';
  }

  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static DateFields = ['EntryDateUtc'];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Client Payment ID',
        orderById: 'TpClientPaymentId',
        data: TpPrePaymentPaymentItem.GetDetailCellContent,
        minWidth: 20
      },
      { label: 'Payment Date', orderById: 'EntryDateUtc', data: 'EntryDateUtc', minWidth: 40 },
      {
        label: 'Paid',
        orderById: 'AmountPaid',
        data: 'AmountPaid',
        minWidth: 20
      },
      {
        label: 'Check Number',
        orderById: 'CheckNumber',
        data: 'CheckNumber',
        minWidth: 40
      },
      {
        label: 'Transaction ID',
        orderById: 'LineItemPaymentId',
        data: 'LineItemPaymentId',
        minWidth: 40
      }
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.TpClientPaymentId,
      '',
      '',
      'new_clientpaymentdetails',
      `id=${item.TpClientPaymentId}`,
      'Open up in a new tab'
    );
  }
}
